import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "sbd_cookie_consent";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setOpen(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    localStorage.setItem(`${KEY}_at`, new Date().toISOString());
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[65] font-body"
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookie-Hinweis"
        >
          <div className="bg-[#0A0A0A] border border-white/15 shadow-2xl shadow-black/60 p-6">
            <div className="flex items-center gap-3 mb-3">
              <Cookie size={20} className="text-[#FF3B00]" />
              <span className="font-display text-lg text-white">Cookies & Datenschutz</span>
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-5">
              Wir verwenden ausschließlich technisch notwendige Cookies, damit diese Website
              funktioniert. Es findet kein Tracking und keine Weitergabe an Dritte statt. Mehr dazu in
              unserer{" "}
              <Link to="/datenschutz" className="text-[#FF3B00] hover:underline" data-testid="cookie-datenschutz-link">
                Datenschutzerklärung
              </Link>.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => choose("all")}
                className="flex-1 bg-[#FF3B00] text-white font-tech text-xs uppercase tracking-[0.12em] py-3 hover:bg-[#FF5C2B] active:scale-95 transition-all"
                data-testid="cookie-accept"
              >
                Alle akzeptieren
              </button>
              <button
                onClick={() => choose("necessary")}
                className="flex-1 border border-white/20 text-neutral-300 font-tech text-xs uppercase tracking-[0.12em] py-3 hover:border-white/50 hover:text-white transition-colors"
                data-testid="cookie-necessary"
              >
                Nur notwendige
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
